export function convertDateToParamAsIsoDate(dateTime: Date): string {
    return dateTime.toISOString().replace(/\..*/gi, '');
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function padLeft(value: string, pad: string, maxLength: number) {
    if (value.length >= maxLength || maxLength <= 0 || pad.length <= 0) {
        return value;
    }

    while (value.length < maxLength) {
        value = pad + value;
    }

    return value;
}

export function jsonReplacer(key: any, value: any) {
    // value - уже строка
    //@ts-ignore
    const sourceValue = this[key];
    //console.log(`key: ${key}\nthis: ${JSON.stringify(this)}\nvalue: ${value}\nsourceValue: ${sourceValue}`)
    if (sourceValue === null || sourceValue === undefined) {
        return null;
    }

    if (sourceValue instanceof Date) {
        return convertDateToParamAsIsoDate(sourceValue as Date);
    }

    return value;
}